import { CardHeader, Skeleton } from "@mui/material";
import React from "react";

const AppCardHeader = ({ title, subheader, loading, skeleton, ...props }) => {
  if (loading) {
    return (
      skeleton || (
        <CardHeader
          title={<Skeleton variant="text" width="30%" />}
          subheader={<Skeleton variant="text" width="50%" />}
        />
      )
    );
  }

  return (
    <CardHeader title={title || ""} subheader={subheader || ""} {...props} />
  );
};

export default AppCardHeader;
